import { API_BASE_URL } from '../../../../utils/utils';

export const GRE_API_LEGACY_PREFIX = '/api/gre';
export const GRE_API_PREP_TESTS_PREFIX = '/api/prep-tests/gre';

const GRE_PATH_REWRITES = [
  ['/api/gre/boost-status', '/api/prep-tests/gre/boost'],
  ['/api/gre/daily-articles', '/api/prep-tests/gre/daily-content'],
  ['/api/gre/articles/history', '/api/prep-tests/gre/previous-content'],
  ['/api/gre/article/', '/api/prep-tests/gre/exercises/article/'],
];

export const shouldUsePrepTestsGreApi = () => {
  const mode = String(process.env.REACT_APP_GRE_API_MODE || '').toLowerCase();

  if (mode === 'legacy' || mode === 'production') {
    return false;
  }

  // Only opt into prep-tests routes when explicitly configured.
  // Current local and production backends both expose /api/gre/*.
  return mode === 'prep-tests';
};

export const getGreApiPrefix = () =>
  shouldUsePrepTestsGreApi()
    ? GRE_API_PREP_TESTS_PREFIX
    : GRE_API_LEGACY_PREFIX;

export const greApiUrl = (path = '') => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${getGreApiPrefix()}${normalizedPath}`;
};

const applyGrePathRewrites = (url) => {
  if (!shouldUsePrepTestsGreApi()) {
    return url;
  }

  let rewritten = url;

  for (const [from, to] of GRE_PATH_REWRITES) {
    if (rewritten.includes(from)) {
      rewritten = rewritten.replace(from, to);
    }
  }

  if (rewritten.includes('/api/gre/')) {
    rewritten = rewritten.replace('/api/gre/', '/api/prep-tests/gre/');
  }

  return rewritten;
};

export const rewriteGreApiUrl = (url) => {
  if (typeof url !== 'string' || !url.includes('/api/gre')) {
    return url;
  }

  return applyGrePathRewrites(url);
};
